import Reflux from "reflux";
import * as Immutable from "immutable";
import fetch from "logic/rest/FetchProvider";
import { singletonStore } from "logic/singleton";
import { qualifyUrl } from "util/URLUtils";
import GroupSyncBackend from "../../logic/directoryServices/GroupSyncBackend";
import GroupSyncActions from "../../actions/directoryServices/GroupSyncActions";
import Group from "../../logic/directoryServices/Group";
const apiPrefix = "/plugins/org.graylog.plugins.security/team-sync";
const ApiRoutes = {
  GroupsApiController: {
    loadGroups: () => ({ url: `${apiPrefix}/test/backend` }),
    load: (backendId) => ({ url: `${apiPrefix}/services/${backendId}/backend` }),
    update: (backendId) => ({ url: `${apiPrefix}/services/${backendId}/backend` }),
    create: (backendId) => ({ url: `${apiPrefix}/services/${backendId}/backend` }),
    delete: (backendId) => ({ url: `${apiPrefix}/services/${backendId}/backend` })
  }
};
const GroupSyncStore = singletonStore(
  "enterprise.authentication.directoryService.GroupSync",
  () => Reflux.createStore({
    listenables: [GroupSyncActions],
    loadGroups(payload) {
      const promise = fetch(
        "POST",
        qualifyUrl(ApiRoutes.GroupsApiController.loadGroups().url),
        payload
      ).then((response) => {
        if (response) {
          return {
            success: response.success,
            message: response.message,
            errors: Immutable.List(response.errors),
            list: response.result.groups ? Immutable.List(response.result.groups.map((g) => Group.fromJSON(g))) : Immutable.List()
          };
        }
        return null;
      });
      GroupSyncActions.loadGroups.promise(promise);
      return promise;
    },
    create(backendId, payload) {
      const promise = fetch("POST", qualifyUrl(ApiRoutes.GroupsApiController.create(backendId).url), payload).then(
        (response) => ({
          backend: GroupSyncBackend.fromJSON(response.backend)
        })
      );
      GroupSyncActions.create.promise(promise);
      return promise;
    },
    load(backendId) {
      const promise = fetch("GET", qualifyUrl(ApiRoutes.GroupsApiController.create(backendId).url)).then(
        (response) => ({
          backend: GroupSyncBackend.fromJSON(response.backend)
        })
      );
      GroupSyncActions.load.promise(promise);
      return promise;
    },
    update(backendId, payload) {
      const promise = fetch("PUT", qualifyUrl(ApiRoutes.GroupsApiController.update(backendId).url), payload).then(
        (response) => ({
          backend: GroupSyncBackend.fromJSON(response.backend)
        })
      );
      GroupSyncActions.update.promise(promise);
      return promise;
    },
    delete(backendId) {
      const promise = fetch("DELETE", qualifyUrl(ApiRoutes.GroupsApiController.create(backendId).url));
      GroupSyncActions.delete.promise(promise);
      return promise;
    }
  })
);
export { GroupSyncActions, GroupSyncStore };
export default GroupSyncStore;
